import loaded from './modules/preloader.js';

loaded('.preloader');
